import { device } from '@coursera/event-pulse/sdk';

/**
 * Gets the device ID for logged out Coach mode.
 *
 * Returns the eventing device UUID (from event-pulse), which is the same UUID
 * used for all analytics events, ensuring consistency across the platform for
 * device tracking.
 *
 * @returns Device ID string
 */
export function getDeviceId(): string {
  // The uuid from device sdk is always available and can be used for logout mode.
  return device.get().uuid;
}
